// extracted by mini-css-extract-plugin
module.exports = {"root":"colors_root__CZbUu","in-view":"colors_in-view__QdJE2","color":"colors_color__Gkbsf","_header-wrapper":"colors__header-wrapper__A_BPd"};